import { useQuery } from '@tanstack/react-query';
import client from './client';
import type { LeadershipReportDto } from '../types/api';

export const reportKeys = {
  leadership: (weekOf?: string) => ['reports', 'leadership', weekOf] as const,
};

export function useLeadershipReport(weekOf?: string) {
  return useQuery({
    queryKey: reportKeys.leadership(weekOf),
    queryFn: () =>
      client.get<LeadershipReportDto>('/reports/leadership', {
        params: weekOf ? { weekOf } : undefined,
      }).then((r) => r.data),
    staleTime: 5 * 60_000,
  });
}
